import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Create,
  getCustomer,
} from "adminApi/CustomersApi/WakeUpCall";
import { validateForm } from "utils/validation";
import { WakeUpCallValidation } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddWakeUpCallForm from "./Componates/AddWakeUpCallForm";
import fields from "../json/WakeUpCalllFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";      

const AddWakeUpCall = () => {
  const navigate = useNavigate();
  const { formdata } = fields;
  const FeildName = "Wakeup Call"

  // Initialize form values from JSON fields
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  delete initialValues.imagePreview;

  const { values, errors, handleChange,setErrors } = useFormChange(
    initialValues,
    WakeUpCallValidation
  );

  const { data: SelectOptions, loading } = useFetchAllData(getCustomer);

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      return await Create({ data: formValues });
    },
    (vals) => {
      const err = validateForm(vals, WakeUpCallValidation)
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    `${FeildName} Created successfully`
  );

  return (
    <>
      {(loadingSubmit ) && <Spinner isSpinner={true} />}
      <AddWakeUpCallForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        SelectOptions={SelectOptions}
        title={FeildName}
      />
    </>
  );
};

export default AddWakeUpCall;
